import { BinderVariant } from "@/types/binders";
import { ResponsiveModal } from "../../ResponsiveModal/ResponsiveModal";
import { EditBinderVariantsModalItem } from "./EditBinderVariantsModalItem";
import { useMemo } from "react";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  binderItems: BinderVariant[];
  onSelectBinderItem: (binderItem: BinderVariant) => void;
}

export function SelectBinderVariantsModal({
  open,
  onOpenChange,
  binderItems,
  onSelectBinderItem,
}: Props) {
  const sortedBinderItems = useMemo(() => {
    return [...binderItems].sort((a, b) => {
      const createdAtA = new Date(a.created_at);
      const createdAtB = new Date(b.created_at);
      return createdAtB.getTime() - createdAtA.getTime();
    });
  }, [binderItems]);

  return (
    <ResponsiveModal open={open} onOpenChange={onOpenChange} title="Select">
      <div className="grid gap-2">
        {sortedBinderItems.map((binderItem) => (
          <EditBinderVariantsModalItem
            key={binderItem.id}
            binderItem={binderItem}
            onSelect={() => onSelectBinderItem(binderItem)}
          />
        ))}
      </div>
    </ResponsiveModal>
  );
}
